/**
 * `#uc3Insight` — design §4 step 9's "generated insight paragraph from templates using only
 * the approved vocabulary" (`GET uc3/diagnosis`'s own `insight: {en, fr}`, already rendered
 * server-side through `apps.intelligence.templates.uc3_insight` — this component only picks
 * the current language, exactly as `values.sentences` is read in `Uc2.tsx`).
 */
import { useTranslation } from 'react-i18next';

export interface InsightProps {
  insight: { en: string; fr: string };
  limitations?: { en: string; fr: string }[];
}

export function Insight({ insight, limitations = [] }: InsightProps) {
  const { i18n } = useTranslation();
  const lang = i18n.language === 'fr' ? 'fr' : 'en';

  return (
    <div id="uc3Insight" className="intel-insight result-box">
      <div className="result-pad">
        <p>{insight[lang]}</p>
        {limitations.length ? (
          <ul className="tbl-note">
            {limitations.map((line, i) => (
              <li key={i}>{line[lang]}</li>
            ))}
          </ul>
        ) : null}
      </div>
    </div>
  );
}

export default Insight;
